import React from 'react'
import MatchChart from 'lib/components/charts/match-chart'
import Container from 'lib/components/charts/container'
import EasingBox from './shapes/easing-box'
import Grid from 'lib/components/charts/grid'
import GroupsLog from 'lib/components/charts/layouts/groups-log'
import SecondaryXAxis from 'lib/components/charts/secondary-x-axis'
import XAxis from 'lib/components/charts/x-axis'
import YAxis from 'lib/components/charts/y-axis'
import Title from './title'

class ValuationBoxWhisker extends React.PureComponent {
  // These options are passed into the GroupsLog layout
  static defaultProps = {
    data: [],
    margin: 0.15,
    padding: 0.5,
    primary: 'primary',
    secondary: 'categoryShortName',
    width: 300,
    height: 225,
    ticksY: 4,
    formatX: n => n,
    formatY: n => n,
    pluckX: d => d.primary,
    pluckY: d => [d.lower, d.upper],
    vertical: true
  }

  renderBoxes(data, x, y) {
    return data.map(record => this.renderBox(record, x, y))
  }

  renderBox(box, x, y) {
    const width = x.bandwidth()
    const opacity = box.isActive ? 1 : 0.25

    return (
      <EasingBox
        id={box.id}
        key={box.key}
        x={x(box.primary)}
        width={width}
        current={y(box.current)}
        lower={y(box.lower)}
        median={y(box.median)}
        upper={y(box.upper)}
        opacity={opacity}
        category={box.category}
        label={box.label}
        fill={box.fill}
      />
    )
  }

  hasManyGroups() {
    let fields = this.props.data.map(d => d[this.props.secondary])

    if (fields.length <= 0) {
      return false
    }

    return fields.some(field => field !== fields[0])
  }

  renderGroup(data, x, y, key, layout) {
    const { formatX, width } = this.props

    const offset = x.bandwidth() * 0.5
    const box = layout.boundingBox

    return (
      <g key={key}>
        {this.renderBoxes(data, x, y)}

        <MatchChart breakpoint="large" width={width}>
          <XAxis
            scale={x}
            format={formatX}
            ticks={x.domain()}
            y={box.bottom}
            height={box.gutterBottom}
            offset={offset}
            vertical
          />
        </MatchChart>

        <MatchChart breakpoint="small" width={width}>
          <SecondaryXAxis
            data={data}
            scale={x}
            y={box.bottom}
            title={key}
            multi={this.hasManyGroups()}
          />
        </MatchChart>
      </g>
    )
  }

  render() {
    const { data, width, height, labelY, title, formatY } = this.props

    const layout = new GroupsLog(data, this.props)
    const { scaleX, scaleY } = layout

    return (
      <Container width={width} height={height}>
        <Grid
          scaleX={scaleX}
          scaleY={scaleY}
          ticksX={layout.getTicksX()}
          ticksY={layout.getTicksY()}
        />

        <Title x={layout.boundingBox.left} y={layout.boundingBox.top}>
          {title}
        </Title>

        {layout.map(this.renderGroup, this)}

        <YAxis
          label={labelY}
          scale={scaleY}
          format={formatY}
          ticks={layout.getTicksY()}
          height={height}
          width={scaleX.range()[0]}
        />
      </Container>
    )
  }
}

export default ValuationBoxWhisker



// WEBPACK FOOTER //
// ./src/components/charts/valuation-box-whisker.js